import { render, staticRenderFns } from "./MailApprovalView.vue?vue&type=template&id=7b7650bc"
import script from "./MailApprovalView.ts?vue&type=script&lang=ts&external"
export * from "./MailApprovalView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports